import * as yup from 'yup';
import { IValidator } from '../IValidator';
import { AlunoModel } from './Model';

const alunoSchema = yup.object().shape<AlunoModel>({
  id: yup.number(),
  cpf: yup.string(),
  email: yup.string(),
  matricula: yup.string(),
  nome: yup.string(),
  serie: yup.string(),
  turma: yup.string(),
  alunoAtivo: yup.boolean(),
  sit: yup.string()
});

export const AlunoModelValidator = new IValidator<AlunoModel>(alunoSchema);